import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import Maps from '../Maps';

Meteor.publish('maps', function maps() {
  return Maps.find({ owner: this.userId });
});

Meteor.publish('maps.all', function maps() {
  return Maps.find({ owner: this.userId });
});

// Note: maps.view is also used when editing an existing document.
Meteor.publish('maps.view', function mapsView(mapId) {
  check(mapId, String);
  return Maps.find({ _id: mapId, owner: this.userId });
});

Meteor.publish('maps.public', publicMapId => {
  check(publicMapId, String);
  return Maps.find(
    { publicId: publicMapId, shared: true, deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});

Meteor.publish('maps.publicUser', publicMapId => {
  check(publicMapId, String);
  return Maps.find(
    { publicUserId: publicMapId, sharedUser: true, deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});

Meteor.publish('maps.publicPrivate', publicMapId => {
  check(publicMapId, String);
  return Maps.find(
    { publicPrivateId: publicMapId, sharedPrivate: true, deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});

Meteor.publish('maps.publicUserPrivate', publicMapId => {
  check(publicMapId, String);
  return Maps.find(
    { publicUserPrivateId: publicMapId, sharedPrivateUser: true, deleted: { $eq: 'no' } },
    {
      fields: {
        // TODO: poner los campos que no quiero compartir.
        owner: 0
      }
    }
  );
});
